<template>
    <b-modal id="modalSinistro" data-backdrop="static" data-keyboard="false" v-model="exibirItens" centered
        :title="this.$t('Sinalizar Sinistro')">
        <div>
            <span for="obsItem">{{ $t('Observação') }}:</span>
            <input v-model="observacao" type="text" class="form-control" id="obsItem">
        </div>
        <div class="container mt-3 anexoArquivos">
            <h6>{{ $t('Anexo de arquivos') }}:</h6>
            <UploadArquivos></UploadArquivos>
        </div>
        <template #modal-footer>
            <div class="w-100">
                <div class="row center" style="justify-content: center;">
                    <b-button class="mr-2" variant="danger" size="lg" @click="$emit('fechaModal')">
                        {{ $t('Cancelar') }}
                    </b-button>
                    <b-button size="lg" variant="success" @click="sinalizarSinistro">
                        {{ $t('Sinalizar Sinistro') }}
                    </b-button>
                </div>
            </div>
        </template>
    </b-modal>
</template>
<script>
import UploadArquivos from './UploadArquivos.vue';

export default {
    name: "ModalExterna",
    props: {
        os: {},
        item: {}
    },
    data() {
        return {
            selectServico: "",
            observacao: "",
            exibirItens: true,
            idConjunto: "",
            fornecedores: ""
        };
    },
    computed: {
        getFornecedores() {
            const fornecedores = this.$store.getters['filial/fornecedores'];
            if (!fornecedores) {
                this.$store.dispatch('filial/getFornecedores');
                return [];
            }
            return fornecedores.map(fornecedor => {
                return {
                    ...fornecedor,
                    label: fornecedor.ds_fornecedor
                };
            });
        }
    },
    methods: {

        sinalizarSinistro() {
            if (document.getElementById('formFiles').value == '') {
                this.$swal.fire({
                    title: this.$t('Oops!'),
                    text: this.$t('Insira um anexo para registrar o sinistro!'),
                    icon: 'warning'
                })
                // this.$emit('fechaModal')

                return false
            } else {
                document.getElementById('modalSinistro').style.display = 'none'
            }

            this.$root.confirmIdentity({
                onConfirmIdentity: (tecnicoId) => {
                    this.$emit('fechaModal')
                    const filial = this.$store.getters['filial/filial']

                    const sinistro = {
                        observacao: this.observacao,
                        cd_clifor: tecnicoId,
                        ordem_servico: this.$route.params.id,
                        data_os: this.os,
                        ds_colaborador: filial.dsColaborador
                    }

                    const files = this.$store.state.os.filesUpload

                    const formData = new FormData();

                    for (let i = 0; i < files.length; i++) {
                        formData.append('files[]', files[i]);
                    }

                    this.$store.dispatch(`os/uploadFilesOrdemServico`, { data: formData, nrSeqOs: this.$route.params.id }).then((response)  => {
                        this.$store.dispatch('os/sinalizarSinistro', { data: sinistro }).then(() => {
                            this.$emit('fechaModal')
                            window.location.pathname = '/'
                        })
                        
                    })

                }
            })
        },

    },
    components: { UploadArquivos }
}
</script>
<style>
#modalItems {
    pointer-events: none !important;
}

.close {
    display: none !important;
}
</style>